<template>
  <el-drawer
    :append-to-body="true"
    :title="titleValue"
    :visible.sync="newCodeDialog"
    custom-class="drawerClass"
    direction="ltr"
    size="520px"
    @close="handleNewCodeDialog"
  >
    <div style="padding: 0 20px; overflow-y: auto; height: calc(100vh - 120px); margin-bottom: 40px">
      <el-form
        ref="addFormRef"
        :inline="false"
        :model="addForm"
        :rules="rules"
        class="search-form"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <!-- 流向名称 -->
            <el-form-item :label="$t('routes.flowName')" prop="flowDirectName" style="width: 100%">
              <el-input
                v-model="addForm.flowDirectName"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 选择干支线 -->
            <el-form-item :label="$t('routes.selectTrunkLine')" prop="type">
              <el-select
                v-model="addForm.type"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
                @change="handleType"
              >
                <el-option key="1" :label="$t('basicData.trunkLine')" :value="1" />
                <el-option key="2" :label="$t('basicData.branchLine')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
<!--          <el-col v-if="addForm.type !== 2" :span="24">-->
<!--            &lt;!&ndash; 选择班次 &ndash;&gt;-->
<!--            <el-form-item :label="$t('routes.selectSchedule')" prop="scheduleNumber">-->
<!--              <el-select-->
<!--                v-model="addForm.scheduleNumber"-->
<!--                :placeholder="$t('GlobalSetObj.pleaseChoose')"-->
<!--                clearable-->
<!--                filterable-->
<!--                style="width: 100%"-->
<!--              >-->
<!--                <el-option-->
<!--                  v-for="(item, index) in scheduleNumberList"-->
<!--                  :key="index"-->
<!--                  :label="item"-->
<!--                  :value="item"-->
<!--                />-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="24">
            <!--   最晚到达时间  -->
            <el-form-item
              :label="$t('routes.latestArrivalTime')"
              prop="latestArriveTime"
              style="width: 100%"
            >
              <el-time-picker
                v-model="addForm.latestArriveTime"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                format="HH:mm"
                value-format="HH:mm"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--发车转运中心-->
            <el-form-item
              :label="$t('routes.departureTransferCenter')"
              prop="departTransferCenterId"
            >
              <el-select
                v-model="addForm.departTransferCenterId"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                filterable
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in transferCenterList"
                  :key="item.siteId"
                  :label="item.siteName"
                  :value="item.siteId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--  发车时间  -->
            <el-form-item :label="$t('routes.发车时间')" prop="departureTime" style="width: 100%">
              <el-time-picker
                v-model="addForm.departureTime"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                format="HH:mm"
                value-format="HH:mm"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-card v-for="(stop, index) in addForm.nextSiteList" :key="index" shadow="hover">
          <div style="text-align: right;">
            <el-button
              v-if="addForm.nextSiteList.length > 1" type="text" size="mini"
              icon="el-icon-close" @click="removeStop(index)"
            />
          </div>
          <el-row :gutter="20">
            <el-col :span="24">
              <!-- 下一站流向 -->
              <el-form-item
                :label="$t('routes.下一站流向')"
                :prop="`nextSiteList.${index}.nextSiteId`"
                :rules="rules.nextSiteId"
              >
                <el-select
                  v-model="stop.nextSiteId" :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable filterable style="width: 100%"
                >
                  <el-option
                    v-for="item in siteList" :key="item.siteId"
                    :label="item.siteName" :value="item.siteId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 预计到达时间 -->
              <el-form-item
                :label="$t('routes.estimatedArrivalTime')"
                :prop="`nextSiteList.${index}.expectedArriveTime`"
                :rules="rules.expectedArriveTime"
                style="width: 100%"
              >
                <el-time-picker
                  v-model="stop.expectedArriveTime"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  format="HH:mm"
                  value-format="HH:mm"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 是否跨天 -->
              <el-form-item
                :label="$t('routes.crossDay')"
                :prop="`nextSiteList.${index}.acrossDay`" :rules="rules.acrossDay"
                style="width: 100%"
              >
                <el-select
                  v-model="stop.acrossDay"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable filterable style="width: 100%"
                >
                  <el-option
                    v-for="item in isAcrossDay"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <div class="demo-drawer__footer">
          <el-button
            type="primary" @click="addNextStop"
          >{{ $t('GlobalSetObj.addNextStop') }}
          </el-button>
          <div>
            <!--  取消 -->
            <el-button
              @click="handleNewCodeDialog"
            >{{ $t('GlobalSetObj.cancel') }}
            </el-button>
            <!-- 确定 -->
            <el-button
              type="primary" @click="submitForm"
            >{{ $t('GlobalSetObj.determine') }}
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import { branchLineModifyApi, getScheduleNumber } from '@/api/newExpressAPI';
import { routes } from '@/lang/type/newRoutes'; // 校验函数：确保输入为数字
// 校验函数：确保输入为数字
export default {
  props: {
    transferCenterList: {
      type: Array,
      default: () => []
    },
    siteList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newCodeDialog: false,
      timeValue: [],
      addForm: {
        flowDirectName: '', // 流向名称
        type: 1, // 干支线  1干线  2支线
        scheduleNumber: '', // 班次编号
        latestArriveTime: '', // 最晚到达时间
        departTransferCenterId: '', // 发车转运中心id
        departureTime: '', // 发车时间
        nextSiteId: '', // 下一站流向id
        expectedArriveTime: '', // 预计到达时间
        acrossDay: '', // 是否跨天（天数）
        nextSiteList: [{
          nextSiteId: '', // 下一站流向 ID
          expectedArriveTime: '', // 预计到达时间
          acrossDay: '' // 是否跨天
        }]
      },
      rules: {
        flowDirectName: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' }
        ],
        type: [{ required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }],
        scheduleNumber: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ],
        latestArriveTime: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ],
        departTransferCenterId: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ],
        departureTime: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ],
        nextSiteId: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }
        ],
        expectedArriveTime: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }
        ],
        acrossDay: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }
        ]
      },
      titleValue: this.$t('GlobalSetObj.add'),
      scheduleNumberList: [],
      isAcrossDay: [
        { label: this.$t('collectionCenter.sameDay'), value: 0 },
        { label: '+1', value: 1 },
        { label: '+2', value: 2 },
        { label: '+3', value: 3 },
        { label: '+4', value: 4 },
        { label: '+5', value: 5 },
        { label: '+6', value: 6 }
      ],
      editId: ''
    };
  },
  computed: {
    routes() {
      return routes;
    }
  },
  methods: {
    removeStop(index) {
      this.addForm.nextSiteList.splice(index, 1);
    },
    addNextStop() {
      this.addForm.nextSiteList.push({
        nextSiteId: '', // 下一站流向 ID
        expectedArriveTime: '', // 预计到达时间
        acrossDay: '' // 是否跨天
      });
    },
    handleType() {
      this.addForm.scheduleNumber = '';
      this.addForm.latestArriveTime = '';
      this.addForm.departTransferCenterId = '';
    },
    submitForm() {
      this.$refs['addFormRef'].validate(async(valid) => {
        if (valid) {
          if (this.editId) {
            const data = {
              ...this.addForm,
              id: this.editId
            };
            const res = await branchLineModifyApi(data);
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            }
          } else {
            const res = await branchLineModifyApi(this.addForm);
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            }
          }
          this.handleNewCodeDialog();
          this.$emit('invoke-search', null);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 控制弹框
    openCodeDialog(row) {
      if (row.id) {
        this.titleValue = this.$t('collectionCenter.modify');
        this.editId = row.id;
        this.addForm = row;
        row.nextSiteList.forEach(list => {
          if (list.acrossDayName) {
            delete list.acrossDayName;
          }
        });
        this.addForm = {
          flowDirectName: row.flowDirectName, // 流向名称
          type: row.type, // 干支线  1干线  2支线
          scheduleNumber: row.scheduleNumber, // 班次编号
          latestArriveTime: row.latestArriveTime, // 最晚到达时间
          departTransferCenterId: row.departTransferCenterId, // 发车转运中心id
          departureTime: row.departureTime, // 发车时间
          nextSiteId: row.nextSiteId, // 下一站流向id
          expectedArriveTime: row.expectedArriveTime, // 预计到达时间
          acrossDay: row.acrossDay, // 是否跨天（天数）
          nextSiteList: row.nextSiteList || []
        };
      } else {
        this.editId = '';
        this.titleValue = this.$t('GlobalSetObj.add');
        this.addForm = {
          flowDirectName: '', // 流向名称
          type: 1, // 干支线  1干线  2支线
          scheduleNumber: '', // 班次编号
          latestArriveTime: '', // 最晚到达时间
          departTransferCenterId: '', // 发车转运中心id
          departureTime: '', // 发车时间
          nextSiteId: '', // 下一站流向id
          expectedArriveTime: '', // 预计到达时间
          acrossDay: '', // 是否跨天（天数）
          nextSiteList: [{
            nextSiteId: '', // 下一站流向 ID
            expectedArriveTime: '', // 预计到达时间
            acrossDay: '' // 是否跨天
          }]
        };
      }
      this.getScheduleNumberList();
      console.log(this.addForm, 'openCodeDialog');
      this.newCodeDialog = true;
    },
    handleNewCodeDialog() {
      this.$refs['addFormRef'].resetFields();
      this.newCodeDialog = false;
      this.editId = '';
    },
    // 班次编号下拉框
    getScheduleNumberList() {
      getScheduleNumber().then((res) => {
        if (res.code === 200) {
          this.scheduleNumberList = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 0 0 20px 0;
  background: #f2f2f2;
}
::v-deep .el-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
::v-deep .el-card__body {
  padding: 10px;
  box-sizing: border-box;
}
.demo-drawer__footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding-top: 20px;
  box-sizing: border-box;
}
</style>
